<template>
  <div v-if="isPermission && isEditData">
    <CCard class="shadow-sm m-2">
      <CCardBody>
        <CRow>
          <CCol sm="1" col="2">
            <img src="/img/icon/store.png" style="width: 32px; height: 32px" />
          </CCol>
          <CCol sm="9" col="8">
            <select class="custom-select text-black" v-model="shop" disabled>
              <option v-for="shop in shops" :key="shop.objectId" :value="shop">
                {{ shop.shopName }} - {{ shop.branchName }}
              </option>
            </select>
          </CCol>
          <div class="col-md-2 col-sm-2 col-2 text-right" v-if="loadingButton == true">
            <CButton block color="light" @click="$router.go(-1)">
              <span
                ><i
                  class="fi fi-rr-arrow-left mr-2"
                  style="position: relative; top: 2px"
                ></i></span
              >{{ $t("back") }}
            </CButton>
          </div>
          <div class="col-md-2 col-sm-2 text-right" v-else>
            <CButton block color="success" disabled>
              <CSpinner color="white" size="sm" />{{ $t("loading") }}
            </CButton>
          </div>
        </CRow>
      </CCardBody>
    </CCard>
    <!-- Body information -->
    <CCol md="12" lg="12">
      <CCard class="shadow-sm">
        <CCardBody>
          <CRow>
            <CCol md="10">
              <h2 class="font-weight-normal">
                {{ $t("createPOTXT") }}
              </h2>
            </CCol>
            <CCol md="2">
              <CButton
                v-show="currentSection == 1"
                id="createAdjustStockAddProductButton"
                class="btn btn-outline-success btn-block"
                style="display: flex; align-items: center; justify-content: center"
                @click="openSelectProductModal"
              >
                <i class="fi fi-rr-plus" style="margin-right: 8px"></i>
                {{ $t("addProduct") }}
              </CButton>
            </CCol>
          </CRow>
          <CRow>
            <CCol col="12">
              <AppStepProgressBar
                :stepLabels="stepLabels"
                :currentStep="currentSection + 1"
                :stepNum="3"
              />
            </CCol>
          </CRow>
          <hr />
          <div v-show="currentSection == 0">
            <CDataTable
              :key="componentIndex"
              id="createAdjustStockDataTable"
              :fields="prdocFields"
              :items="processedDocuments"
              hover
              border
              v-model="prDocItem"
            >
              <template slot="nameproduct-header">
                <p></p>
              </template>
              <template #selected="{ item, index }">
                <td
                  :id="'createAdjustStockSelectedRow' + index"
                  style="vertical-align: middle; text-align: center"
                >
                  <div class="custom-control custom-checkbox" style="padding-left: 2rem">
                    <input
                      type="checkbox"
                      class="custom-control-input success cursor"
                      v-model="item.selected"
                      @change="selectPR(item)"
                      :id="index"
                    />
                    <label class="custom-control-label cursor" :for="index"> </label>
                  </div>
                </td>
              </template>
              <template #name="{ item }">
                <td class="text-dark" style="vertical-align: middle; border-left: hidden">
                  {{ item.docNo }}
                </td>
              </template>
              <template #status="{ item }">
              <td>
              <CBadge :class="getStatusColor(item.status)"> {{ item.status }}
              </CBadge>
              </td>
              </template>
              <template #no-items-view>
                <div class="text-center my-5">
                  <h4 style="color: #ced2d8">
                    {{ $t("noItem") }}
                  </h4>
                </div>
              </template>
            </CDataTable>
          </div>
          <div v-show="currentSection == 1 ">
            <div class="mt-3">
              <table
                id="createStockInTable"
                style="white-space: nowrap"
                v-if="items.length != 0"
                class="table table-sm table-responsive table-bordered mb-4"
              >
                <thead>
                  <tr>
                    <th class="text-center text-dark font-weight-normal">#</th>
                    <th></th>
                    <th class="text-dark font-weight-normal">{{ $t("pluCode") }}</th>
                    <th class="text-dark font-weight-normal">{{ $t("productName") }}</th>
                    <th class="text-dark font-weight-normal">{{ $t("unit") }}</th>
                    <th class="text-right text-dark font-weight-normal">
                      {{ $t("quantity") }}
                    </th>
                    <th class="text-right text-dark font-weight-normal">
                      {{ $t("stockUnit") }}
                    </th>
                    <th
                      
                      class="text-right text-dark font-weight-normal"
                    >
                      {{ $t("discount") }}
                    </th>
                    <th
                      
                      class="text-right text-dark font-weight-normal"
                    >
                      {{ $t("total") }}
                    </th>
                    <th
                      style="width: 13%;"
                      class="text-dark font-weight-normal"
                    >
                      {{ $t("supplier") }}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td class="text-center text-dark font-weight-normal">
                      <div style="margin-top: 6px">{{ index + 1 }}</div>
                    </td>
                    <td style="width: 5%">
                      <div
                        v-if="item.remoteImagePath"
                        :style="{
                          'background-image': `url('${item.remoteImagePath}'), url('${noImg}')`,
                          'background-size': 'cover',
                          'background-position': 'center center',
                          width: 'auto',
                          'border-radius': '2px',
                          'aspect-ratio': '1.3',
                          'min-width': '50px',
                        }"
                      ></div>
                      <div
                        v-else
                        :style="{
                          'aspect-ratio': '4 / 3',
                          'min-width': '50px',
                          backgroundColor: item.indexColor,
                        }"
                      ></div>
                    </td>
                    <td>{{ item.productPLU.PLUCode || "" }}</td>
                    <td style="width: 30%">
                      <span v-if="item.vatType === 'N'">
                        {{ item.productPLU.name || "" }}
                        <CBadge color="danger">Non VAT</CBadge>
                      </span>
                      <span v-else>{{ item.productPLU.name || "" }}</span>
                    </td>
                    <td>
                      {{
                        item.productPLU.unit ? item.productPLU.unit.name || "-" : "-"
                      }}/{{ item.productPLU.SKURatio || "1" }}
                    </td>
                    <td>
                      <input
                        style="width: 100%; height: 100%"
                        type="number"
                        min="0"
                        v-model.number="item.quantity"
                        class="form-control form-control-md text-right text-dark font-weight-normal"
                      />
                    </td>
                    <td>
                      <input
                        style="width: 100%; height: 100%"
                        type="number"
                        min="0"
                        class="form-control form-control-md text-right text-dark font-weight-normal"
                        v-model.number="item.cost"
                      />
                    </td>
                    <td >
                      <input
                        style="width: 100%; height: 100%"
                        type="number"
                        min="0"
                        class="form-control form-control-md text-right text-danger font-weight-normal"
                        v-model.number="item.discount"
                      />
                    </td>
                    <td >
                      <input
                        style="width: 100%; height: 100%"
                        class="form-control form-control-md text-right text-dark font-weight-normal"
                        :value="grandTotalItem(item)"
                        disabled
                      />
                    </td>
                    <td >
                     <input
                      class="form-control form-control-md text-dark font-weight-normal"
                      disabled
                      v-model="item.supplierName"
                     />
                    </td>
                    <td class="text-center" style="width: 2%">
                      <CButton color="danger" size="sm" @click="removeProduct(item)">
                        <CIcon name="cil-trash"></CIcon>
                      </CButton>
                    </td>
                  </tr>
                </tbody>
              </table>
              <CDataTable v-else id="createStockInEmptyTable">
                <template #no-items-view>
                  <div class="text-center my-5">
                    <h4 style="color: #ced2d8">
                      {{ $t("noItem") }}
                    </h4>
                  </div>
                </template>
              </CDataTable>

              <div v-if="validateItem" class="text-danger">{{ validateItem }}</div>
              <p class="text-danger" v-if="warning != ''">{{ warning }}</p>
              <p v-if="duplicateItem != ''" class="text-danger">{{ duplicateItem }}</p>
            </div>
          </div>
          <div v-show="currentSection == 2">
            <CRow>
              <CCol v-for="(supplier, index) in supplierList" :key="index" md="12">
                <CCard class="p-4 mb-3 supplier-card-body">
                  <CRow class="align-items-center mb-3">
                    <CCol>
                      <h3 class="font-weight-bold">{{ supplier.name }}</h3>
                    </CCol>
                  </CRow>
                  <CRow class="mb-3">
                    <CCol md="4">
                      <label class="font-weight-bold">Due Date :</label>
                      <VueDatePicker
                        id="createPODatePicker"
                        color="#29B46B"
                        :locale="getDateLocale()"
                        :visible-years-number="90"
                        v-model="dueDate"
                        format="DD-MM-YYYY"
                        class="form-control text-dark"
                      >
                        <template v-slot="{ inputValue, inputEvents }">
                          <input
                            id="createPRDatePickerInput"
                            :value="inputValue"
                            v-on="inputEvents"
                          />
                        </template>
                      </VueDatePicker>
                    </CCol>
                    <CCol md="4">
                      <label class="font-weight-bold">Credit Term :</label>
                      <select
                        v-model="supplier.creditTerm"
                        class="form-control"
                      ><option v-for="credit in creditOptions" :key="credit.value" :value="credit.value">
                      {{ credit.text }}
                      </option></select>
                    </CCol>
                    <CCol md="4">
                      <label class="font-weight-bold">VAT Type :</label>
                      <select
                        v-model="supplier.vatType"
                        class="form-control"
                      ><option v-for="vat in vatOptions" :key="vat.value" :value="vat.value">
                      {{ vat.text }}
                      </option></select>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol md="12">
                      <label class="font-weight-bold">Note :</label>
                      <textarea
                        v-model="supplier.note"
                        rows="3"
                        class="form-control"
                        placeholder="Notes"
                      ></textarea>
                    </CCol>
                  </CRow>
                </CCard>
              </CCol>
            </CRow>
          </div>
          <CCol>
            <div class="row justify-content-end mb-4" style="margin: 0">
              <CButton
                id="createPRCancel"
                class="btn col-lg-2 col-4 shadow-sm text-dark font-weight-normal"
                style="margin-right: 15px"
                color="light"
                @click="backSection()"
              >
                {{ currentSection === 0 ? $t("skip") : $t("back") }}
              </CButton>
              <CButton
                id="createPRHandlepopup"
                class="btn btn-success col-lg-2 col-4 font-weight-normal"
                @click="goNext()"
              >
              {{ currentSection === 3 ? $t("save") : currentSection === 0 ? $t("submit") : $t("next") }}
            </CButton>
            </div>
          </CCol>
        </CCardBody>
      </CCard>
    </CCol>

    <!-- Confirm modal -->
    <CRow>
      <CModal
        id="createPRPopupModal"
        :show.sync="popupModal"
        color="success"
        :title="$t('confirmSaveDoc')"
        centered
        :footer="footer"
      >
        <br />
        <h4 class="text-center">{{ $t("คุณต้องการบันทึกใบสั่งซื้อใช่หรือไม่") }}</h4>
        <br />
        <template #footer>
          <CRow class="justify-content-around col-md-12">
            <CCol col="6">
              <CButton
                id="createPRCancelButton"
                block
                color="light"
                @click="popupModal = false"
                class="font-weight-normal"
              >
                {{ $t("cancel") }}
              </CButton>
            </CCol>
            <CCol col="6">
              <CButton
                id="createPRSaveButton"
                block
                color="success"
                v-if="loadingButton === true"
                v-on:click="$router.push('/inventory/purchase/po')"
              >
                {{ $t("save") }}
              </CButton>
              <CButton
                id="createPRSaveDisabledButton"
                block
                color="success"
                v-else-if="loadingButton === false"
                disabled
              >
                <CSpinner color="white" size="sm" /> {{ $t("save") }}
              </CButton>
            </CCol>
            
          </CRow>
        </template>
      </CModal>
    </CRow>

    <!-- Select Product modal -->
    <AppSupplierProductPicker
      ref="select_product_component"
      :limitItem="limitSelectProduct"
      @update-selected-items="updateSelectedProducts"
    >
    </AppSupplierProductPicker>
  </div>
  <div v-else>
    <access-data></access-data>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "@/services/local";
import util from "@/util/util";
import Multiselect from "vue-multiselect";
import permis from "@/util/permission";
import Pagination from "@/containers/Pagination";
import AppStepProgressBar from "@/components/AppStepProgressBar";
import AppSupplierProductPicker from "@/components/AppSupplierProductPicker";
import { CBadge } from "@coreui/vue";

export default {
  components: {
    Multiselect,
    Pagination,
    AppStepProgressBar,
    AppSupplierProductPicker,
  },
  data() {
    return {
      currentSection: 0,
      isSuccess: false,
      alert: false,
      data: [],
      datetime: new Date(),
      shop: this.$store.getters.shopObjectId,
      member: null,
      members: [],
      isVatIncluded: false,
      billNo: "",
      note: "",
      discount: "0",
      searchBy: "name",
      label: "name",
      keyword: "",
      autoCompleteResult: [],
      items: [],
      vatType: "",
      validateShop: "",
      validateItem: "",
      popupModal: false,
      footer: "",
      loadingButton: true,
      duplicateItem: "",
      warning: "",
      permission: false,
      AddProductModal: false,
      AddCheckStockModal: false,
      keywordEntered: "",
      selectedItems: [],
      all: false,
      isshowAlert: 0,
      dataCategory: [],
      selectedCategory: "",
      supplier: null,
      supplierList: [
        {
          name: "Coke Shop",
          id: 1,
        },
        {
          name: "RK Shop",
          id: 2,
        },
      ],
      dueDate: new Date(),
      prDocItem: [],
      stepLabels: [
        this.$t("selectPR"),
        this.$t("selectdProduct"),
        this.$t("PO Detail"),
      ],
      componentIndex: 0,
      supplierList: [
        { id: 1, name: "Coke Shop" },
        { id: 2, name: "RK Shop" },
        { id: 3, name: "ABC Supplies" },
        { id: 4, name: "XYZ Traders" },
      ],
      limitSelectProduct: 100,
      supplierList: [
        {
          name: "Coke Shop",
          dueDate: "20-02-2568",
          creditTerm: "30",
          vatType: "None VAT",
          note: "",
        },
        {
          name: "RK Trading",
          dueDate: "15-03-2568",
          creditTerm: "45",
          vatType: "7% VAT",
          note: "Urgent order",
        },
      ],
      creditOptions: [
        { value: "15", text: "15" },
        { value: "30", text: "30" },
        { value: "45", text: "45" },
        { value: "60", text: "60" },
      ],
      vatOptions: [
        { value: "None VAT", text: "None VAT" },
        { value: "Including VAT", text: "Including VAT" },
        { value: "Excluding VAT", text: "Excluding VAT" },
      ],
      documents: [],
    };
  },
  computed: {
    ...mapGetters(["shops", "users", "date", "access", "permissions"]),
    uid() {
      return `${localStorage.getItem("shopsUid")}`;
    },
    isPermission() {
      let path = "/inventory/stock-in";
      return permis.findPermissionRead("inventory", path);
    },
    isEditData() {
      let path = "/inventory/stock-in";
      return permis.findPermissionEdit("inventory", path);
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },
    startDate() {
      return moment(String(this.date.start)).format("DD MMMM YYYY");
    },
    shopOptions() {
      let detail = [];
      this.shops.forEach((shop) => {
        detail.push({
          value: shop,
          label: shop.shopName + " - " + shop.branchName,
        });
      });
      return detail;
    },
    memberOptions() {
      let detail = [];
      this.members.forEach((member) => {
        detail.push({
          value: member,
          label: member.name,
        });
      });
      return detail;
    },
    noImg() {
      return process.env.VUE_APP_NOIMAGE;
    },
    prdocFields() {
      return [
        {
          key: "selected",
          label: this.$i18n.t("selectd"),
          _style: "width:5%; vertical-align: middle;",
          _classes: "text-center text-dark font-weight-normal",
        },
        {
          key: "createdDate",
          label: this.$t('createdAt'),
          _style: "width:15%",
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "docNo",
          label: this.$t('documentNo'),
          _style: "width:15%",
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "supplier",
          label: this.$t('supplier'),
          _style: "width:20%",
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "dueDate",
          label: this.$t('dueDate'),
          _style: "width:15%",
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "createdBy",
          label: this.$t('createBy'),
          _style: "width:10%",
          _classes: "font-weight-normal text-dark",
        },
        {
          key: "status",
          label: this.$t('status'),
          _style: "width:10%",
          _classes: "font-weight-normal text-dark",
        },
      ];
    },
    processedDocuments() {
      let data = this.documents || [];
      let detail = [];
      for (let i = 0; i < this.documents.length; i++) {
        let item = data[i];
        const docNo = item.docNo || "-";
        const createdBy = item.createdBy || "-";

        const createdDate =
          moment(String(item.created_at)).format("DD/MM/YYYY HH:mm:ss") || "-";
        const supplier = item.supplier?.name || "-";
        const checkStockName = item.note || "-";
        const status = item.status || "Pending";
        const dueDate = moment(String(item.dueDate)).format("DD/MM/YYYY") || "-";
        const processedItems = item.items
          ? item.items.map((items) => ({
              ...items,
              selected: false,
            }))
          : [];
        detail.push({
          docNo: docNo,
          createdDate: createdDate,
          checkStockName: checkStockName,
          supplier: supplier,
          createdBy: createdBy,
          status: status,
          dueDate: dueDate,
          objectId: item.objectId || "-",
          id: item.id,
          items: processedItems,
          selected: false,
        });
      }
      return detail;
    },
    memberslist() {
      const member = this.members || [];
      let detail = [];
      for (let i = 0; i < member.length; i++) {
        const item = member[i];
        const fullName =
          (item.firstname || item.name || "") + " " + (item.lastname || "");
        detail.push({
          id: item.id,
          objectId: item.objectId,
          name: fullName,
        });
      }
      return detail;
    },
  },
  created() {
    this.getMember();
    this.shop = this.shops.find((i) => i.objectId === this.shop);
    this.fetchDocuments();
  },
  methods: {
    ...util,
    openSelectProductModal(index) {
      this.selectedIndex = index;
      this.$refs.select_product_component.openModal();
    },
    selectPR(item) {

      let parsedItems = JSON.parse(JSON.stringify(item.items || []));

      if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
        console.warn("No valid items found in selected PR document.");
        return;
      }

      let selectedProducts = [];

      parsedItems.forEach((docItem, index) => {
        if (!docItem.productPLU) return;

        const existingIndex = this.items.findIndex(
          (selected) => selected.PLUCode === docItem.productPLU.PLUCode
        );

        if (existingIndex === -1) {
          let newItem = {
            docNo: item.docNo,
            orderIndex: this.items.length + index,
            PLUCode: docItem.productPLU.PLUCode || "-",
            name: docItem.productPLU.name || "-",
            productPLU: docItem.productPLU || {},
            productSKU: docItem.productSKU || {},
            quantity: docItem.quantity || 0,
            vatType: docItem.productSKU?.vatType || "V",
            cost: docItem.cost || 0,
            discount: docItem.discount || 0,
            total: docItem.total || 0,
            supplier: docItem.supplier || null,
            remoteImagePath: docItem.remoteImagePath || docItem.ProductPLU?.remoteImagePath || "",
            indexColor: docItem.productSKU?.indexColor || "#cccccc",
            selected: true,
            supplierName: docItem.supplier?.name || this.$t('noSupplier')
          };

          selectedProducts.push(newItem);
        }
      });


      if (item.selected) {
        this.items.push(...selectedProducts);
      } else {
        this.items = this.items.filter((selected) => selected.docNo !== item.docNo);
      }
    },
    async fetchDocuments() {
      const uid = this.uid;
      const shopObjectId = this.shopObjectId;
      const params = { shopObjectId: shopObjectId };
      let url = "http://localhost:3002/pr/alldoc";

      const headers = { shopObjectId: this.$store.getters.shopObjectId };

      await axios
        .get(url, { params, headers })
        .then((res) => {
          this.documents = res.data || [];
          this.componentIndex = this.componentIndex + 1;
        })
        .catch((error) => {
          console.error("Error fetching documents:", error);
        });
    },
    getDateLocale() {
        return this.$i18n.locale
    },
    noImgUrl(event) {
      event.target.src = process.env.VUE_APP_NOIMAGE;
    },
    handlePopup() {
      if (this.shopObjectId === "") {
        this.popupModal = false;
        this.validateShop = this.$i18n.t("selectShopPlease");
      } else {
        this.validateShop = "";
      }

      if (this.items.length === 0) {
        this.popupModal = false;
        this.validateItem = this.$i18n.t("selectProductPlease");
      } else {
        this.validateItem = "";
      }

      if (this.items.length != 0 && this.shopObjectId != "") {
        this.popupModal = true;
      }
    },
    removeProduct(i) {
      let items = this.items;
      let newItems = items.filter((item) => item.orderIndex != i.orderIndex);
      this.items = newItems;
      let index = this.autoCompleteResult.findIndex(
        (x) => x.objectId == i.productPLU.objectId
      );
      if (index != -1) {
        this.autoCompleteResult[index].selected = false;
      }

      let find = this.selectedItems.findIndex(
        (x) => x.objectId === i.productPLU.objectId
      );
      if (find != -1) {
        this.selectedItems.splice(i, 1);
      }
    },
    grandTotalItem(item) {
      let total = 0;
      if (item.vatType === "N") {
        total = item.quantity * item.cost - item.discount;
      }
      if (item.vatType === "V") {
        total = item.quantity * item.cost - item.discount;
      } else {
        total = item.quantity * item.cost - item.discount;
      }
      return (item.total = total);
    },
    getMember() {
      const uid = this.uid;
      const shopObjectId = this.shopObjectId;

      const params = {
        shopObjectId: shopObjectId,
      };
      const headers = {
        shopObjectId: shopObjectId,
      };
      axios({
        url: "/api/v1.0/" + uid + "/getmember",
        params: params,
        headers: headers,
        method: "GET",
      })
        .then((res) => {
          this.members = res.data.data.documents;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateSelectedProducts(selectedProducts) {
      this.items = selectedProducts.map((product) => ({
        productPLU: product.ProductPRU?.productPLU || {},
        productSKU: product.ProductSKU || {},
        PLUCode: product.PLUCode || "-",
        name: product.name || "-",
        quantity: product.quantity || 0,
        cost: product.cost || 0,
        discount: product.discount || 0,
        total: product.total || 0,
        vatType: product.vatType || "V",
        supplier: product.supplier || null,
        remoteImagePath: product.remoteImagePath || "",
        indexColor: product.indexColor,
        selected: true,
        supplierName: product.supplier?.name || this.$t('noSupplier')
      }));
    },
    // formSubmit(e) {
    //   this.loadingButton = false;
    //   this.shop = this.shops.find((i) => i.objectId === this.shopObjectId);
    //   e.preventDefault();

    //   const plan = this.users.currentPlan;
    //   this.items.forEach((item) => {
    //     delete item.remoteImagePath;
    //     delete item.indexColor;
    //   });

    //   let data = {
    //     billNo: this.billNo,
    //     date: new Date(this.datetime).toISOString(),
    //     discount: util.currencyStringToNumber(this.discount),
    //     grandTotal: util.currencyStringToNumber(this.grandTotal),
    //     isVatIncluded: !this.isVatIncluded,
    //     netTotal: this.netTotal,
    //     note: this.note,
    //     shop: {
    //       id: this.shop.id,
    //       objectId: this.shop.objectId,
    //       shopName: this.shop.shopName,
    //       branchName: this.shop.branchName,
    //     },
    //     shopId: this.shop.id,
    //     stockDocType: 1,
    //     vatBase: 7,
    //     uid: this.uid,
    //     vat: this.vat,
    //     items: this.items,
    //     vatType: this.vatType,
    //   };

    //   if (this.member != null) {
    //     data["customerId"] = this.member.id || "";
    //     data["customer"] = {
    //       id: this.member.id || "",
    //       objectId: this.member.objectId || "",
    //       name: this.member.name || "",
    //     };
    //   }

    //   const headers = {
    //     shopObjectId: this.$store.getters.shopObjectId,
    //   };
    //   if (data.shopId != undefined && data.items.length != 0) {
    //     axios({
    //       method: "post",
    //       url: "",
    //       params: {
    //         shopObjectId: data.shopObjectId,
    //         plan: plan,
    //       },
    //       data: data,
    //       headers: headers,
    //     })
    //       .then(() => {
    //         // setTimeout(() => {
    //         //   (this.isSuccess = true),
    //         this.isSuccess = true;
    //         this.$router.push("/inventory/purchase/pr");
    //         // }, 5000);
    //       })
    //       .catch(function (error) {
    //         console.log(error);
    //       });
    //   }
    // },
    getPRDoc() {
      const uid = this.uid;
      const shopObjectId = this.shopObjectId;
      const params = {
        shopObjectId: shopObjectId,
      };
      const docObjectId = this.$route.params.objectId;
      let url = "http://localhost:3002/pr" + "?objectId=" + docObjectId;

      const headers = {
        shopObjectId: this.$store.getters.shopObjectId,
      };

      axios
        .get(url, {
          params,
          headers,
        })
        .then((res) => {
          this.documents = res.data;
        })
        .catch((error) => {
          console.error("Error fetching documents:", error);
        });
    },
    onCheckboxChange() {
      let data = this.selectedItems;
      let items = this.items;
      let select = [];
      let isshowAlert = 0;
      data.forEach((item, index) => {
        if (items.length < 200) {
          let stdCost = 0;
          let SKURatio = 1;
          let totalCost = 0;
          if (item.selected) {
            select.push(item);
            if (
              item.ProductSKU.stdCost === undefined ||
              item.ProductSKU.stdCost === null
            ) {
              stdCost = 0;
            } else {
              stdCost = item.ProductSKU.stdCost;
            }

            if (item.SKURatio == undefined) {
              SKURatio = 1;
            } else {
              SKURatio = item.SKURatio;
            }

            totalCost = SKURatio * stdCost;
            let checkCount = item.checkCount;
            let quantity = checkCount !== undefined ? checkCount : 0;
            let vatType = item.ProductSKU.vatType;
            if (items.length > 0) {
              let i = items.findIndex((x) => x.productPLU.objectId === item.objectId);
              if (i == -1) {
                items.push({
                  cost: totalCost,
                  discount: 0,
                  orderIndex: index,
                  productPLU: {
                    id: item.id,
                    objectId: item.objectId,
                    PLUCode: item.PLUCode,
                    name: item.name,
                    unit: item.unit,
                    SKURatio: SKURatio,
                  },
                  productPLUId: item.id,
                  quantity: quantity,
                  total: 0,
                  productSKUObjectId: item.ProductSKU.objectId,
                  productSKU: item.ProductSKU || {},
                  remoteImagePath: item.remoteImagePath,
                  indexColor: util.generateColor(item.indexColor),
                  vatType: vatType,
                });
              }
            } else {
              items.push({
                cost: totalCost,
                discount: 0,
                orderIndex: index,
                productPLU: {
                  id: item.id,
                  objectId: item.objectId,
                  PLUCode: item.PLUCode,
                  name: item.name,
                  unit: item.unit,
                  SKURatio: SKURatio,
                },
                productPLUId: item.id,
                quantity: quantity,
                total: 0,
                productSKUObjectId: item.ProductSKU.objectId,
                productSKU: item.ProductSKU || {},
                remoteImagePath: item.remoteImagePath,
                indexColor: util.generateColor(item.indexColor),
                vatType: vatType,
              });
            }
          } else {
            let index = items.findIndex((x) => x.productPLU.objectId === item.objectId);
            if (index != -1) {
              items.splice(index, 1);
            }
          }
        } else {
          isshowAlert = 5;
        }
      });
      this.isshowAlert = isshowAlert;
      this.items = items;
      this.selectedItems = select;
      this.all = false;
    },
    backSection() {
      if (this.currentSection == 0) {
        this.currentSection += 1;
      } else if (this.currentSection == 1) {
        this.items = [];
        this.selectedItems = [];
        this.prDocItem = [];
        this.currentSection -= 1;
      } else {
        this.currentSection -= 1;
      }
    },
    goNext() {
      if (this.currentSection == 1) {
        this.onCheckboxChange();
        this.currentSection += 1;
      } else if (this.currentSection == 3) {
        this.handlePopup();
      } else  {
        this.currentSection += 1;
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "Completed":
          return "status-success"; 
        case "Canceled":
          return "status-danger"; 
        case "Pending":
          return "status-light"; 
        case "In Progress":
          return "status-primary";
        default:
          return "status-light";
      }
    },
  },
};
</script>

<style scoped>
.supplier-card-body {
  border-radius: 25px !important;
  border: 2px solid #dddddd;
  overflow: hidden;
}
.no-border-radius-left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

.no-border-radius-right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.multiselect__tags {
  min-height: 35px;
  padding: 0px 40px 0 8px;
}

.multiselect__placeholder {
  margin-top: 6px;
  margin-bottom: 7px;
}

.multiselect__single {
  margin-top: 6px;
  padding-left: 5px;
  margin-bottom: 8px;
}

.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

/* Hidden arrow  */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.status-success {
  background-color: rgba(40, 167, 69, 0.5) !important; /* Success จาง */
  color: #155724; 
  border-radius: 10px;
}

.status-danger {
  background-color: rgba(220, 53, 69, 0.5) !important; /* Danger จาง */
  color: #721c24;
  border-radius: 10px;
}

.status-light {
  background-color: #e0e0e0 !important; /* Light */
  color: #6c757d;
  border-radius: 10px;
}

.status-primary {
  background-color: rgba(0, 123, 255, 0.5) !important; /* Primary จาง */
  color: #004085;
  border-radius: 10px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="../../../assets/styles/inventory.css" scoped></style>
